import React from 'react';
import { Chip } from '../../../../ui';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { BookingStatus as BookingStatusEnum } from '../../domain/booking/models/IBooking';

interface IBookingStatusProps {
	status: BookingStatusEnum;
}

export const BookingStatus = ({ status }: IBookingStatusProps) => {
	const { t } = useTranslation();

	return (
		<Chip variation={status === 'canceled' ? 'error' : 'brand'}>
			{status === 'canceled'
				? t('parking_booking_status_cancelled')
				: t('parking_booking_status_confirmed')}
		</Chip>
	);
};
